import React from 'react';

const ProgressDashes = ({ total = 5, current = 5 }) => {
  return (
    <div className="d-flex align-items-center gap-2">
      {/* Dashes */}
      {Array.from({ length: total }).map((_, index) => (
        <div
          key={index}
          style={{
            width: '20px',
            height: '8px',
            borderRadius: '8px',
            backgroundColor: index < current ? 'green' : '#e0e0e0',
          }}
        />
      ))}

      {/* Count */}
      <div
        style={{
          padding: '2px 12px',
          backgroundColor: '#d4fcd4',
          borderRadius: '20px',
          fontSize: '0.9rem',
          fontWeight: 600,
          color: 'green',
        }}
      >
        {current}/{total}
      </div>
    </div>
  );
};

export default ProgressDashes;